import { ContentBlock, FlexContainer, TitledBlock } from 'components';
import {
  featuresOptions,
  outsideSpaceOptions,
  parkingOptions,
} from 'config/propertyFields';

/**
 * PropertyBaseDetails
 *
 * @return {JSX.Element}
 */
const PropertyBaseDetails = ({ property }) => {
  return (
    <>
      <TitledBlock title="Features">
        <FlexContainer gap wrap>
          {property.propertyFeatures?.length ? (
            property.propertyFeatures.map((f) => {
              const item = featuresOptions.find(({ key }) => key === f);

              return item ? (
                <ContentBlock key={f}>{item.value}</ContentBlock>
              ) : null;
            })
          ) : (
            <ContentBlock>None</ContentBlock>
          )}
        </FlexContainer>
      </TitledBlock>
      <TitledBlock title="Outside space">
        <FlexContainer gap wrap>
          {property.propertyOutsideSpaces?.length ? (
            property.propertyOutsideSpaces.map((f) => {
              const item = outsideSpaceOptions.find(({ key }) => key === f);

              return item ? (
                <ContentBlock key={f}>{item.value}</ContentBlock>
              ) : null;
            })
          ) : (
            <ContentBlock>None</ContentBlock>
          )}
        </FlexContainer>
      </TitledBlock>
      {property.propertyParking ? (
        <TitledBlock title="Parking">
          <FlexContainer>
            <ContentBlock>
              {
                parkingOptions.find(
                  ({ key }) => key === property.propertyParking
                )?.value
              }
            </ContentBlock>
          </FlexContainer>
        </TitledBlock>
      ) : null}
    </>
  );
};

PropertyBaseDetails.displayName = 'PropertyBaseDetails';

export default PropertyBaseDetails;
